const ObstructionType = {
  ONCE: 'once',
  ONCE_INDEFINITE: 'once_indefinite',
  YEARLY: 'yearly',
};

export default ObstructionType;
